export default __webpack_public_path__ + "static/media/080_finish_soso.hevc.cf367944.mp4";